import styled from 'styled-components';

export const Container = styled.div`

  .item-exp {
    display: flex;
    align-items: center;

    span {
      margin-left: 4px;
    }
  }

  
`;
